export enum QUERY_KEYS {
  createAdmissionPreset = 'create-admission-preset',
  createAdmissionPresetImage = 'create-admission-preset-image',
  deleteAdmissionPreset = 'delete-admission-preset',
  deleteOfferPresetImage = 'delete-offer-preset-image',
  editAdmissionPreset = 'edit-admission-preset',
  getAdmissionsPresets = 'get-admissions-presets',
  getAdmissionsPresetsByType = 'get-admissions-presets-type',
  getPresetChannelsById = 'preset-channels-by-id',
  reorderOfferPresetImages = 'reorder-offer-preset-images',
}
